import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private loginUrl = environment.loginUrl;

  constructor(private http: HttpClient) {}

  login(body: any): Observable<any> {
    return this.http.post(`${this.loginUrl}login`, body).pipe(
      tap((res: any) => {
        if (res?.status === 200 && res?.data) {
          localStorage.setItem('userData', JSON.stringify(res.data));
        }
      })
    );
  }

  logout() {
    localStorage.removeItem('userData');
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('userData');
  }
}
